import React from "react";
import { useNavigate } from "react-router-dom";
import { TrailerFormLayout } from "./components/form";

const TrailerCreatePage: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <TrailerFormLayout
      mode="create"
      title="Create New Trailer"
      onSuccess={() => navigate("/trailers")}
    />
  );
};

export default TrailerCreatePage;





